"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormCategoryItem = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var FormCategoryItem = function (_a) {
    var icon = _a.icon, label = _a.label, onClick = _a.onClick;
    return react_1.default.createElement(storybook_1.Buttons.Button, { onClick: onClick },
        react_1.default.createElement("li", { className: 'storybook-videos-form-category-item' },
            react_1.default.createElement(storybook_1.Icons.Icon, { name: icon, className: 'h-24 mb-2' }),
            react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3' }, label)));
};
exports.FormCategoryItem = FormCategoryItem;
exports.FormCategoryItem.propTypes = {
    /**
     * The icon of FormCategoryItem
     */
    icon: prop_types_1.default.string,
    /**
     * The label of FormCategoryItem
     */
    label: prop_types_1.default.string,
    /**
     * The onClick function of FormCategoryItem
     */
    onClick: prop_types_1.default.func
};
exports.FormCategoryItem.defaultProps = {};
